import { ImsPermissions } from "@redotech/account-common/permissions";
import { useRequiredContext } from "@redotech/react-util/context";
import FlipForwardIcon from "@redotech/redo-icons/flip-forward.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useMatch } from "react-router-dom";

export const TransfersItem = memo(function TransfersItem({
  hidden,
}: {
  hidden?: boolean;
}) {
  const routes = useRequiredContext(MerchantRoutesContext);
  const urlPrefix = `${routes.inventoryManagementBaseUrl}/transfers`;

  const hasPermissionToViewItem = useHasPermission(
    ImsPermissions.ACCESS_TRANSFERS,
  );

  const anyChildSelected = useMatch(`${urlPrefix}/*`);

  if (!hasPermissionToViewItem) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: urlPrefix }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={FlipForwardIcon}
      friendlyName="Transfers"
      hidden={hidden}
      id="transfers"
      UnfilledIcon={FlipForwardIcon}
    />
  );
});
